module.exports = __webpack_public_path__ + "static/media/Q4.8e7bb1b1.jpg";